module.exports = __webpack_public_path__ + "static/media/toggl.cb648e2f.svg";